import axiosIns, { newAxiosIns } from '@/libs/axios'

export function apiCreateBankAccount({
  bank_code,
  bank_name,
  bank_no,
  bank_owner_name,
  mode,
  id,
}) {
  const params = {
    bank_code,
    bank_name,
    bank_no,
    bank_owner_name,
  }
  if (mode === 'edit') {
    params.id = id
    return newAxiosIns.put('auth/api/v1/bank_accounts/update', params)
  }
  return newAxiosIns.post('auth/api/v1/bank-account/komchat', params)
}

export function apiGetBankAccount() {
  return newAxiosIns.get('auth/api/v1/bank_accounts/list')
}

export function apiGetListBank() {
  return newAxiosIns.get('xendit/api/v1/banks')
}

export function apiDeleteBankAccount(id) {
  return newAxiosIns.delete(`/auth/api/v1/bank_accounts/komchat/delete/${id}`)
}
